var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 20.75V2.19406C0.750232 2.12846 0.767668 2.06407 0.80057 2.00731C0.833472 1.95056 0.880686 1.90343 0.9375 1.87063C1.30359 1.65594 2.29312 1.25 4.5 1.25C7.5 1.25 11.2969 3.5 13.5 3.5C14.7439 3.49677 15.9746 3.24546 17.1202 2.76078C17.1344 2.75483 17.1499 2.7525 17.1653 2.75399C17.1807 2.75549 17.1955 2.76076 17.2083 2.76934C17.2212 2.77793 17.2317 2.78955 17.239 2.80319C17.2462 2.81682 17.25 2.83205 17.25 2.8475V13.13C17.2499 13.1663 17.2393 13.2018 17.2194 13.2322C17.1995 13.2625 17.1712 13.2865 17.138 13.3011C16.7517 13.4703 15.3905 14 13.5 14C11.25 14 7.5 12.5 4.5 12.5C1.5 12.5 0.75 13.25 0.75 13.25",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2cf75a84dcf8bdaa24e511ce104a48ea.svg";
export { ForwardRef as ReactComponent };